import { render, staticRenderFns } from "./YA_leftNavBar.vue?vue&type=template&id=59996eb1&scoped=true"
import script from "./YA_leftNavBar.vue?vue&type=script&lang=js"
export * from "./YA_leftNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59996eb1",
  null
  
)

export default component.exports